/**
 * CargaKarcherCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaKarcher} from '@/model/resource/CargaKarcher'

/* TODO: review generated class */
@HttpExclude()
export class CargaKarcherCollection extends PageCollection<CargaKarcher> {
  constructor() {
    super(CargaKarcher)
  }

  queryAsPage() {
    return this.listCargaKarcher()
  }

  async listCargaKarcher() {
    return await Request.get(`/admin/carga-karcher`, {params: this.params})
      .name('listCargaKarcher')
      .as(this)
      .getResponse()
  }

  async listCsvCargaKarcher() {
    return await Request.get(`/admin/carga-karcher/csv`, {params: this.params})
      .name('listCsvCargaKarcher')
      .as(this)
      .getResponse()
  }
}
